import React from 'react';
import { Link } from 'react-router-dom';
import { sampleTransaction } from '../../data/gtbankUatData';
import Div from '../Div';
import Spacing from '../Spacing';
import { UatPageShell } from './UatDocumentationPage';

const contentByStatus = {
  SUCCESS: {
    title: 'Payment Successful',
    breadcrumb: 'Success',
  },
  FAILED: {
    title: 'Payment Not Successful',
    breadcrumb: 'Failed',
  },
  CANCELLED: {
    title: 'Payment Cancelled',
    breadcrumb: 'Cancelled',
  },
};

export default function PaymentResultPage({ status }) {
  const config = contentByStatus[status];

  return (
    <UatPageShell
      title={config.title}
      breadcrumb={config.breadcrumb}
      heading={config.title}
      subtitle="GTBank MPGS UAT result screen"
    >
      {status === 'SUCCESS' ? (
        <>
          <p className="cs-m0">Reference Number: {sampleTransaction.referenceNumber}</p>
          <p className="cs-m0">Payment Reference: {sampleTransaction.paymentReference}</p>
          <p className="cs-m0">Gateway Transaction ID: {sampleTransaction.gatewayTransactionId}</p>
          <p className="cs-m0">Amount: {sampleTransaction.currency} {sampleTransaction.amount}</p>
          <p className="cs-m0">Date: {sampleTransaction.dateLong}</p>
          <Spacing lg="18" md="14" />
          <p className="cs-m0">Your payment has been completed successfully.</p>
        </>
      ) : null}
      {status === 'FAILED' ? (
        <>
          <p className="cs-m0">Reason: Insufficient Funds</p>
          <p className="cs-m0">Reference Number: {sampleTransaction.referenceNumber}</p>
          <Spacing lg="18" md="14" />
          <p className="cs-m0">
            Your transaction was not successful. Reason: Insufficient Funds. Please contact support
            with your reference number.
          </p>
        </>
      ) : null}
      {status === 'CANCELLED' ? (
        <>
          <p className="cs-m0">Reference Number: {sampleTransaction.referenceNumber}</p>
          <Spacing lg="18" md="14" />
          <p className="cs-m0">The hosted checkout process was cancelled before payment completion.</p>
        </>
      ) : null}
      <Div style={{ marginTop: 28 }}>
        <Link to="/payment" className="cs-btn cs-style1" style={{ display: 'inline-flex' }}>
          <span>Back to payment</span>
        </Link>
      </Div>
    </UatPageShell>
  );
}
